import { useEffect, useState } from "react";
import { _CompetitionType, _DocumentFactory, _Entailment, _MacroProcess, _single, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _IncomeCompensationDocument } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { FileService } from "../../../../core/services/FileService";
import usePaginator from "../../../theme/Component/usePaginator";
import { DocumentStateTypes } from "./DocumentStateTypes";
import { BasicButton } from "../../../theme/Component/BasicButton";
import useModal, { MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { DropDown } from "../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";

interface Props {
    IDDocument: any;
    DocumentDate: any;
}


export const IncomeCompensationDocument = ({ IDDocument, DocumentDate }: Props) => {

    const IncomeCompensationDocument = useDataBean(_IncomeCompensationDocument);
    const [regexStr, setregexStr] = useState<string>(null)
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const [docstype, setDocstype] = useState<any>(0);
    const _documentos = useDataBean(_DocumentFactory);
    const [registro, setregistro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const fileService = new FileService();
    const paginador = usePaginator();
    const paginador2 = usePaginator();
    const [lista, setLista] = useState<any>([]);
    const [listaAll, setListaAll] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const modalDownload = useModal("Consolidado", MODAL_SM);


    useEffect(() => {
        getLista();
    }, [IDDocument, DocumentDate, paginador.page])

    useEffect(() => {
        if (registro.view) {
            verDocumentos();
        }
    }, [registro.view]);

    const getLista = () => {

        IncomeCompensationDocument.instance.getIncomeCompensationDocumentCatalog(IDDocument, DocumentDate, docstype, regexStr, paginador.page, 15).then(
            (resp: any) => {
                console.log(resp)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)
                let x = resp.List;
                x.forEach(item => {
                    item.DataBeanProperties.TerceroID = (item.DataBeanProperties.AccountID ?? "") + " " + (item.DataBeanProperties.AccountName ?? "");
                    item.DataBeanProperties.Doc = (item.DataBeanProperties.Mnemonic ?? "") + " " + (item.DataBeanProperties.Consecutive ?? "");
                    // item.DataBeanProperties.Titular = (item.DataBeanProperties.LoanAccountID ?? "") + " " + (item.DataBeanProperties.LoanAccountName ?? "");
                    item.DataBeanProperties.Proceess = (item.DataBeanProperties.IDProcesss ?? "") + " " + (item.DataBeanProperties.ProcessDate ?? "");
                    item.DataBeanProperties.Employee = (item.DataBeanProperties.EmployeeID ?? "") + " " + (item.DataBeanProperties.EmployeeName ?? "")
                    if (item.DataBeanProperties.LoanMediaContext) {
                        item.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(item.DataBeanProperties.LoanMediaContext, item.DataBeanProperties.LoanMedia)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                    } else {
                        item.DataBeanProperties.URL = "Sin Documento";
                    }
                });
                setLista(x)
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const getListaAll = () => {

        IncomeCompensationDocument.instance.getIncomeCompensationDocumentCatalog(IDDocument, DocumentDate, docstype, regexStr, paginador.page, paginador.records+20).then(
            (resp: any) => {
                console.log(resp)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)
                let x = resp.List;
                x.forEach(item => {
                    item.DataBeanProperties.TerceroID = (item.DataBeanProperties.AccountID ?? "") + " " + (item.DataBeanProperties.AccountName ?? "");
                    item.DataBeanProperties.Doc = (item.DataBeanProperties.Mnemonic ?? "") + " " + (item.DataBeanProperties.Consecutive ?? "");
                    // item.DataBeanProperties.Titular = (item.DataBeanProperties.LoanAccountID ?? "") + " " + (item.DataBeanProperties.LoanAccountName ?? "");
                    item.DataBeanProperties.Proceess = (item.DataBeanProperties.IDProcesss ?? "") + " " + (item.DataBeanProperties.ProcessDate ?? "");
                    item.DataBeanProperties.Employee = (item.DataBeanProperties.EmployeeID ?? "") + " " + (item.DataBeanProperties.EmployeeName ?? "")
                    if (item.DataBeanProperties.LoanMediaContext) {
                        item.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(item.DataBeanProperties.LoanMediaContext, item.DataBeanProperties.LoanMedia)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                    } else {
                        item.DataBeanProperties.URL = "Sin Documento";
                    }
                });
                setListaAll(x)
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const create = () => {
        IncomeCompensationDocument.setBean({

            DocumentDate: DocumentDate
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        IncomeCompensationDocument.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDIncomeCompensationDocument', visible: true },
        { title: 'Tercero Compensado', property: 'TerceroID', visible: true },
        { title: 'Documento', property: 'Doc', visible: true },
        { title: 'Fecha de Documento', property: 'DocumentDate', visible: true },
        { title: 'Estado Documento', property: 'DocumentStateName', visible: true },
        { title: 'Cuenta Contable Compensada', property: 'AccountantIDName', visible: true },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'No Crédito', property: 'LoanNumber', visible: true },
        // { title: 'Vr. Cuota', property: 'IDLoanQuota', visible: true },
        { title: 'Archivo de Carga Masiva', property: 'URL', visible: false },
        { title: 'Nit Titular', property: 'LoanAccountID', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre Titular', property: 'LoanAccountName', visible: true },
        { title: 'No Proceso', property: 'IDProcess', visible: true, mask: MASK_NUMBER },
        { title: 'Funcionario', property: 'Employee', visible: false },
    ];


    const listaBotones = () => {
        const botones = [

            { titulo: "Ver Documento", icono: "ri-file-list-line", visible: true, evento: () => { setregistro({ ...registro, "view": true }) }, },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const verDocumentos = () => {

        if (IncomeCompensationDocument.bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(IncomeCompensationDocument.bean.IDDocument, null, IncomeCompensationDocument.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setregistro({ ...registro, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }
    }

    const actionsDropDown = [
        { id: 1, name: 'Descargar Consolidado', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getListaAll();
                            modalDownload.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }


    return (
        <div className="row">
            <div className="col-md-4">
                <DocumentStateTypes idSelector={docstype} onChange={(e) => { setDocstype(e) }} />
            </div>
            <div className="col-md-4">
                <label>Búsqueda por Texto</label>
                <input type="text" name="Name" className="form-control" value={regexStr} onChange={(e: any) => { setregexStr(e.target.value) }} />
            </div>
            <div className="col-md-4 mt-4 p-2">
                <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                    Buscar
                </BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={IncomeCompensationDocument.setBean} listButtons={listaBotones()}
                    pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={registro} updateModal={setregistro}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docs}
                                IDDocument={IncomeCompensationDocument.bean.IDDocument}
                                Since={IncomeCompensationDocument.bean.DocumentDate}
                            />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            {listaAll.length > 0 &&
                                <ExportXLSL customName={'compensacion'} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                    single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>
                </Modal>

            </div>

        </div>
    )
}